import React from 'react'

import { x } from 'utils/emotion'

const EquifyImage = () => {
  return (
    <x.div textAlign="center" marginBottom="xlarge">
      <x.img w="140px" src="/assets/logos/equify_text.svg" />
    </x.div>
  )
}

export default React.memo(EquifyImage)
